/*
 * Mode the user is reading the book in. Not applicable with ReaderMode.Webtoon
 */
export enum WritingStyle{
  Horizontal = 0,
  Vertical = 1,
}
